"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var commonFunctions_1 = require("../../../../commonFunctions");
var AnnualHomeBicycleInfo = /** @class */ (function (_super) {
    __extends(AnnualHomeBicycleInfo, _super);
    function AnnualHomeBicycleInfo(props) {
        return _super.call(this, props) || this;
    }
    AnnualHomeBicycleInfo.prototype.render = function () {
        var _this = this;
        var bicycles = this.props.bicycles;
        var filteredBicycles = bicycles ? bicycles.filter(function (bicycle) { return bicycle.flowValuable; }) : [];
        if (filteredBicycles && filteredBicycles.length > 0) {
            var items = filteredBicycles.map(function (item) {
                return (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: "mt-2 mb-3 margin-top-28 margin-bottom-2" }, _this.renderItemPanel(item)),
                    React.createElement("div", { className: "border-bottom-dashed-blue mt-2 mb-3" })));
            });
            return (React.createElement.apply(React, __spreadArray(["div", { className: "mt-0 mb-0" }], items, false)));
        }
        else {
            return React.createElement(React.Fragment, null);
        }
    };
    AnnualHomeBicycleInfo.prototype.renderItemPanel = function (bicycle) {
        var _this = this;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", null,
                React.createElement("b", null, bicycle.description),
                " (",
                (0, commonFunctions_1.getAmountToDisplay)(bicycle.value),
                ")"),
            React.createElement("div", { className: "d-flex justify-content-between justify-content-md-start mt-2 font-weight-bold text-blue-1" },
                React.createElement("span", { onClick: function () { return _this.props.editBicycle(bicycle); }, className: "mr-5 cursor-pointer blue-link-underline" }, "Edit"),
                React.createElement("span", { onClick: function () { return _this.props.removeBicycle(bicycle); }, className: "cursor-pointer ml-auto" },
                    '-\u00A0',
                    " "),
                React.createElement("span", { onClick: function () { return _this.props.removeBicycle(bicycle); }, className: "cursor-pointer blue-link-underline" }, "Remove"))));
    };
    ;
    return AnnualHomeBicycleInfo;
}(React.Component));
exports.default = AnnualHomeBicycleInfo;
//# sourceMappingURL=AnnualHomeBicylecInfo.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/annual/home/valuableItemWidget/AnnualHomeBicylecInfo.js
// module id = 3696
// module chunks = 0